var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"report",rawName:"v-report.pv",value:({f_module:'主页面'}),expression:"{f_module:'主页面'}",modifiers:{"pv":true}}],staticClass:"redeem-container"},[_c('userInfo'),_c('redeem'),_c('instruction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }